export default __webpack_public_path__ + "static/media/fJoy.06214f9e.png";